import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20Korean%20manhwa%20style%20illustration%2C%20dreamy%20fantasy%20landscape%20with%20soft%20blurred%20depth%20of%20field%2C%20cherry%20blossom%20petals%20floating%20in%20golden%20sunlight%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20magical%20sparkling%20atmosphere%2C%20gentle%20bokeh%20effect%2C%20warm%20spring%20evening%20light%2C%20romantic%20and%20serene%20mood%2C%20soft%20focus%20background%20suitable%20for%20text%20overlay&width=1600&height=900&seq=hero-bg-001&orientation=landscape"
        alt="桃桃漫画网 - 韩国漫画在线阅读"
        title="韩国漫画无删减下拉式免费在线阅读"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/40" />

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 w-full">
          <div className="max-w-[600px]">
            <h1 className="font-heading text-[36px] md:text-[56px] font-black text-white leading-[1.15] tracking-tight">
              韩国漫画<br />
              无删减下拉式<br />
              免费在线阅读
            </h1>
            <p className="mt-6 text-base md:text-lg text-white/80 font-medium">
              可爱风格韩漫 · 每日更新 · 畅快下拉体验
            </p>
            <Link
              to="/category/romance"
              className="mt-10 inline-flex items-center gap-2 h-[56px] px-8 bg-accent-500 text-white rounded-full text-[15px] font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line" style={{ width: '16px', height: '16px' }} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}